import React, { useMemo, useReducer } from "react";
import { reducerFn } from "../../helper";
import { useTeamUserFilter } from "../../hooks/useUserTeamByRoles";
import { TEAM_ROLE } from "../../variable";
import AutocompleteV2 from "../shared/AutocompleteV2";
import { fitlerOptions } from "./helper";

export default function ChannelTeamMembers({ onChange, value, roles, label }) {
    const [filter, setFilter] = useReducer(reducerFn, {
        search: "",
    });

    const memberState = useTeamUserFilter({
        value: React.useMemo(() => value, [value]),
        roles,
    });

    const options = useMemo(
        () => fitlerOptions(memberState.options, filter.search),
        [filter.search, memberState.options],
    );

    return (
        <AutocompleteV2
            options={options}
            label={label || "Members"}
            value={value}
            getValueImmediate
            onChange={onChange}
            allowMultiple
            setFilter={setFilter}
        />
    );
}
